import { Children } from "react";
function findByType(type) {
    return this.find(function (child) { return child.type === type; });
}
function filterByType(type) {
    return this.filter(function (child) { return child.type === type; });
}
function filterOutType(type) {
    return this.filter(function (child) { return child.type !== type; });
}
var parseChildren = function (reactChildren) {
    var children = Children.toArray(reactChildren);
    children.findByType = findByType;
    children.filterByType = filterByType;
    children.filterOutType = filterOutType;
    return children;
};
export default parseChildren;
